import { PaginatedResponse } from "@/app/api/types";
import {
  IPrivateContext,
  PrivateContext,
} from "@/app/components/PrivateContextLoader";
import { Entity, ISelectFieldOption } from "@/app/fields/types";
import { useContext } from "react";
import { SelectFieldFilter } from "./SelectFieldFilter";

export function UserFieldFilter<T extends Entity>({
  label,
  field,
  isDisabled,
}: {
  field: string;
  label: string;
  isDisabled: boolean;
}) {
  const { users } = useContext(PrivateContext) as IPrivateContext<T>;
  const getFieldOptions = async (): Promise<
    PaginatedResponse<ISelectFieldOption>
  > =>
    new Promise((resolve) => {
      resolve({
        count: (users || []).length,
        page: 1,
        page_size: 1000,
        results: (users || []).map(({ id, first_name, last_name }) => ({
          value: id,
          label: `${first_name} ${last_name}`,
          group: null,
        })),
      });
    });
  return (
    <SelectFieldFilter
      isDisabled={isDisabled}
      field={field}
      label={label}
      getFieldOptions={getFieldOptions}
    />
  );
}
